import { OrderConstants } from "../_constants";
import * as commonAction from "./commonAction";
import { commonService, socketService } from "../_services";

export const orderActions = {
  getAllOrders,
  markOrderPaid,
  markOrderAccepted,
  assignDeliveryBoy
};


//-- all order function
function getAllOrders(apiName, orderObj) {
  return dispatch => {
    dispatch(commonAction.request(OrderConstants.GET_ALL_ORDER_REQUEST, orderObj));
    commonService.withToken(apiName, orderObj).then(
      bannerData => {
        dispatch(commonAction.success(OrderConstants.GET_ALL_ORDER_SUCCESS, bannerData));
      },
      error => {
        dispatch(commonAction.failure(OrderConstants.GET_ALL_ORDER_FAILURE, error));
      }
    );
  };
}

function markOrderPaid(apiName, orderObj) {
  return dispatch => {
    dispatch(commonAction.request(OrderConstants.MARK_ORDER_REQUEST, orderObj));
    commonService.withToken(apiName, orderObj).then(
      bannerData => {
        dispatch(commonAction.success(OrderConstants.MARK_ORDER_SUCCESS, bannerData));
      },
      error => {
        dispatch(commonAction.failure(OrderConstants.MARK_ORDER_FAILURE, error));
      }
    );
  };
}

//mark order accepted
function markOrderAccepted(apiName, orderObj) {
  return dispatch => {
    dispatch(commonAction.request(OrderConstants.MARK_ORDER_ACCEPTED_REQUEST, orderObj));
    commonService.withToken(apiName, orderObj).then(
      bannerData => {
        socketService.onSocketEmit('orderCreate', {})
        dispatch(commonAction.success(OrderConstants.MARK_ORDER_ACCEPTED_SUCCESS, bannerData));
      },
      error => {
        dispatch(commonAction.failure(OrderConstants.MARK_ORDER_ACCEPTED_FAILURE, error));
      }
    );
  };
}

//-- order assigned to delivery boy
function assignDeliveryBoy(apiName, orderObj) {
  return dispatch => {
    dispatch(commonAction.request(OrderConstants.MARK_ORDER_ACCEPTED_REQUEST, orderObj));
    commonService.withToken(apiName, orderObj).then(
      bannerData => {
        dispatch(commonAction.success(OrderConstants.MARK_ORDER_ACCEPTED_SUCCESS, bannerData));
      },
      error => {
        dispatch(commonAction.failure(OrderConstants.MARK_ORDER_ACCEPTED_FAILURE, error));
      }
    );
  };
}